/**
 * Shared field + footer styling for contract add/edit and “record entry” modals.
 */
export const invModalDateInputClass =
  'bg-transparent outline-none border-none w-full cursor-pointer text-[14px] text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-400';

export const invModalInputClass =
  'w-full px-4 py-2 text-[14px] h-10 rounded-lg border transition-colors bg-gray-100 text-gray-700 border-gray-200 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600';

export const invModalDateShellClass =
  'flex items-center bg-gray-100 dark:bg-gray-700 px-3 pr-[10px] text-[14px] h-10 rounded-lg border border-gray-200 dark:border-gray-600';

export const invModalFormGridClass =
  'grid grid-cols-1 sm:grid-cols-2 gap-x-[1.15rem] gap-y-[1.20rem] sm:gap-y-[1.40rem]';

export const invModalFormFooterClass =
  'flex flex-col-reverse sm:flex-row justify-end gap-2 sm:gap-3 mt-4 sm:mt-5';

export const invModalCancelBtnClass =
  'w-full sm:w-auto px-4 sm:px-6 py-2.5 sm:py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors text-sm sm:text-base touch-manipulation';

export const invModalSubmitBtnClass =
  'w-full sm:w-auto px-4 sm:px-6 py-2.5 sm:py-2 bg-gradient-primary text-white rounded-lg hover:bg-gradient-primary-hover transition-colors flex items-center justify-center min-w-[80px] text-sm sm:text-base touch-manipulation';
